"use strict";
const _ = require("lodash");

const traverse = ({ object, transform, path }) => {
  if (_.isArray(object)) {
    return object.map((value) =>
      traverse({
        object: value,
        transform,
        path: _.compact([path, "*"]).join(".")
      })
    );
  } else if (_.isObject(object)) {
    return _.mapValues(transform({ object, path }), (value, key) =>
      traverse({
        object: value,
        transform,
        path: _.compact([path, key]).join(".")
      })
    );
  }
  return object;
};

const clean = (object) =>
  traverse({
    object: _.cloneDeep(object),
    transform: ({ object: o }) => _.omit(o, ["draft", "diff"])
  });

const draftify = ({ object, path, paths, omit }) =>
  traverse({
    object: _.cloneDeep(object),
    transform: ({ object: o, path }) => {
      const draft = _.omit(o, omit);
      if (paths.includes(path)) {
        draft.draft = true;
      }
      return draft;
    },
    path
  });

const compileRows = ({ current, proposed, compileRow, context }) => {
  const map =
    current?.reduce((acc, row) => {
      acc[row.id] = row;
      return acc;
    }, {}) || {};
  const compiled = { rows: [] };
  const ids = {};
  proposed?.forEach((r) => {
    const m = map[r.id];
    const { row, draft } = compileRow({
      proposed: r,
      current: m,
      context
    });
    if (draft) {
      compiled.draft = true;
    }
    compiled.rows.push(row);
    ids[r.id] = true;
  });
  current?.forEach((row) => {
    if (!row.draft && !ids[row.id]) {
      compiled.rows.push(_.cloneDeep(row));
    }
  });
  return compiled;
};

const compileProperties = ({ properties, before, after, initial }) =>
  properties.reduce((acc, property) => {
    const current = after[property];
    const previous = _.has(before, `diff.${property}`)
      ? before.diff[property].previous
      : before[property];
    if (!_.isEqual(current || null, previous || null)) {
      acc.diff = acc.diff || {};
      acc.diff[property] = _.omitBy({ current, previous }, _.isUndefined);
    }
    acc[property] = current;
    return acc;
  }, initial);

module.exports = {
  clean,
  draftify,
  compileRows,
  compileProperties
};
